import React, {useState} from 'react';

const SellerUser = () => {
  return (
    <></>
  )
}

export default SellerUser;